import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Kontakte(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Buchhaltung"
      title="Kunden und Lieferanten zentral verwalten"
      subtitle="Alle Kontaktdaten, Rechnungshistorie und Kommunikation an einem Ort. Behalten Sie den Überblick über Ihre Geschäftsbeziehungen."
      heroImage="/screenshots/app-kontakte.webp"
      heroImageAlt="Kunden- und Lieferantenverwaltung in Saldify"
      features={[
        {
          title: 'Zentrale Kontaktdatenbank',
          description: 'Speichern Sie alle Kunden- und Lieferantendaten an einem Ort. Mit Suchfunktion und Filteroptionen.',
        },
        {
          title: 'Komplette Historie',
          description: 'Sehen Sie alle Rechnungen, Angebote und Zahlungen pro Kontakt auf einen Blick.',
        },
        {
          title: 'Schnelle Rechnungserstellung',
          description: 'Wählen Sie einen Kontakt und alle Daten werden automatisch in die Rechnung übernommen.',
        },
        {
          title: 'Import & Export',
          description: 'Importieren Sie bestehende Kontakte aus CSV oder Excel. Export jederzeit möglich.',
        },
        {
          title: 'Individuelle Felder',
          description: 'Fügen Sie eigene Felder hinzu: Kundennummer, Ansprechpartner, Notizen und mehr.',
        },
        {
          title: 'DSGVO-konform',
          description: 'Verwalten Sie Einwilligungen und löschen Sie Daten auf Anfrage mit wenigen Klicks.',
        },
      ]}
      sections={[
        {
          title: 'Alle Informationen auf einen Blick',
          description: 'Die Kontaktansicht zeigt Ihnen sofort alle relevanten Informationen: Stammdaten, offene Rechnungen, Zahlungsverhalten und die komplette Kommunikationshistorie.',
          bullets: [
            'Stammdaten und Rechnungsadresse',
            'Offene und bezahlte Rechnungen',
            'Durchschnittliche Zahlungsdauer',
            'Umsatz pro Kunde',
          ],
          imageSide: 'right',
        },
        {
          title: 'Kunden kategorisieren',
          description: 'Ordnen Sie Ihre Kontakte in Gruppen und Kategorien. So behalten Sie auch bei vielen Kunden den Überblick und können gezielt filtern.',
          bullets: [
            'Tags und Kategorien vergeben',
            'Nach Branche oder Region gruppieren',
            'VIP-Kunden markieren',
            'Inaktive Kunden ausblenden',
          ],
          imageSide: 'left',
        },
      ]}
      ctaTitle="Bringen Sie Ordnung in Ihre Kontakte"
      ctaDescription="Importieren Sie Ihre bestehenden Kontakte oder legen Sie neue an – in wenigen Minuten haben Sie alle Daten zentral verfügbar."
    />
  );
}
